import Alpine from "alpinejs";
import Swiper from "swiper";
import { Pagination, EffectFade } from "swiper/modules";
import Cookies from "js-cookie";
import "./components/fitvids";

window.Alpine = Alpine;
window.Cookies = Cookies;
Alpine.start();

let globals = {};

document.addEventListener("DOMContentLoaded", function (event) {
	document.querySelector("html").classList.remove("no-js");

	/**
	 * Scale videos
	 */
	fitVids({
		customSelector: ".wp-block-embed",
	});

	globals.swiper = new Swiper(".swiper", {
		effect: "fade",
		crossFade: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		modules: [Pagination, EffectFade],
	});
});
